import {useTranslation} from 'react-i18next';

import {Theme, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery} from '@mui/material';

import {getViewToggleTabStyles, viewToggleContainerStyles} from './ScreeningViewToggle.styles';

export type ScreeningView = 'applicants' | 'batch_invitations';

interface Props {
  value: ScreeningView;
  onChange: (view: ScreeningView) => void;
}

export const ScreeningViewToggle = ({value, onChange}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'screeningModule.batchInvitationsProgress'});
  const isXs = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <ToggleButtonGroup
      fullWidth
      exclusive
      value={value}
      onChange={(_, nextValue) => {
        if (nextValue) {
          onChange(nextValue);
        }
      }}
      sx={viewToggleContainerStyles}
    >
      <ToggleButton value='applicants' sx={getViewToggleTabStyles(value === 'applicants')}>
        <Typography variant={isXs ? 'h4' : 'h3'}>{t('tabs.applicants')}</Typography>
      </ToggleButton>
      <ToggleButton value='batch_invitations' sx={getViewToggleTabStyles(value === 'batch_invitations')}>
        <Typography variant={isXs ? 'h4' : 'h3'}>{t('tabs.batchInvitations')}</Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
